import { render, staticRenderFns } from "./Page02.vue?vue&type=template&id=5982a2f6&scoped=true&"
import script from "./Page02.vue?vue&type=script&lang=js&"
export * from "./Page02.vue?vue&type=script&lang=js&"
import style0 from "./Page02.vue?vue&type=style&index=0&id=5982a2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982a2f6",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QCard,QCardSection,QList,QItem,QItemSection,QTable,QTr,QTh,QTd,QPagination,QInnerLoading,QSpinnerGears,Ripple} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QCard,QCardSection,QList,QItem,QItemSection,QTable,QTr,QTh,QTd,QPagination,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
